import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip, Tag } from "antd";
import { RouteReasonMap } from "@/utils/enum";
const CustomTag = () => (React.createElement(Tag, { color: "warning" },
    React.createElement(InfoCircleOutlined, null),
    " Hard Route"));
const HardRouteTag = ({ hardRouteLocation, bold }) => {
    if (hardRouteLocation !== null && hardRouteLocation !== undefined) {
        return (React.createElement(Tooltip, { color: "#fff", title: RouteReasonMap[hardRouteLocation], style: { fontWeight: bold ? "bold" : "normal" } },
            React.createElement(CustomTag, null)));
    }
    return React.createElement(CustomTag, null);
};
HardRouteTag.defaultProps = {
    hardRouteLocation: null,
    bold: false,
};
export default HardRouteTag;
